import { TFunction } from 'i18next';
import { OwnerStatus } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

export const getOwnerStatusLabel = (status: OwnerStatus, t: TFunction): string => {
    switch (status) {
        case OwnerStatus.Active:
            return t('superAdmin.data.owners.status.active');
        case OwnerStatus.Inactive:
            return t('superAdmin.data.owners.status.inactive');
        case OwnerStatus.Suspended:
            return t('superAdmin.data.owners.status.suspended');
        default:
            return String(status);
    }
};
